export const H4_BASE_CSS_VARS = {
  "theme-website-h4-color-text": "var(--theme-website-color-text-primary)",
  "theme-website-h4-font-family": "InterVariable",
  "theme-website-h4-font-size": "2.125rem",
  "theme-website-h4-font-weight": "500",
  "theme-website-h4-line-height": "1.3",
  "theme-website-h4-letter-spacing": "0",
};
